/**
 * localStorage utility with expiration support
 * Data is stored with a timestamp and automatically expires after the specified time
 */

const EXPIRATION_TIME = 24 * 60 * 60 * 1000 // 24 hours in milliseconds

/**
 * Save data to localStorage with expiration
 * @param {string} key - Storage key
 * @param {any} data - Data to store
 * @param {number} expirationMs - Expiration time in milliseconds (default: 24 hours)
 */
export const saveToLocalStorage = (key, data, expirationMs = EXPIRATION_TIME) => {
  try {
    const item = {
      data,
      timestamp: Date.now(),
      expiration: expirationMs
    }
    localStorage.setItem(key, JSON.stringify(item))
  } catch (error) {
    console.error('Error saving to localStorage:', error)
  }
}

/**
 * Get data from localStorage (returns null if expired or not found)
 * @param {string} key - Storage key
 * @returns {any|null} - Stored data or null if expired/not found
 */
export const getFromLocalStorage = (key) => {
  try {
    const item = localStorage.getItem(key)
    if (!item) return null

    const parsed = JSON.parse(item)
    const now = Date.now()

    // Check if expired
    if (now - parsed.timestamp > parsed.expiration) {
      localStorage.removeItem(key)
      return null
    }

    return parsed.data
  } catch (error) {
    console.error('Error reading from localStorage:', error)
    return null
  }
}

/**
 * Remove data from localStorage
 * @param {string} key - Storage key
 */
export const removeFromLocalStorage = (key) => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error('Error removing from localStorage:', error)
  }
}

/**
 * Clear all registration form data from localStorage
 */
export const clearRegistrationData = () => {
  const keys = [
    'vendor_registration_step1',
    'vendor_registration_step2',
    'vendor_registration_step3',
    'vendor_registration_step4'
  ]
  keys.forEach(key => removeFromLocalStorage(key))
}

